import React from 'react'
import { CircularProgress, Typography } from '@material-ui/core'

export default ({ label }) => (
  <div style={{ position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, zIndex: 9999, backgroundColor: 'rgba(255,255,255,0.9)', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
    <CircularProgress size={60} thickness={4} />
    <Typography style={{ marginTop: 16 }} variant="h6">{label}</Typography>
  </div>
)